import HIHImage from '@/components/base/HIHImage';
import { ImageMeta } from '@/shared/types/imageMeta';
import React from 'react';
import styles from './ArticleCard.module.scss';

interface ArticleCardProps {
  article: {
    coverImage: ImageMeta;
    title: string;
    shortDescription: string;
  };
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  return (
    <article className={styles.card}>
      <HIHImage
        image={article.coverImage}
        width={100}
        height={100}
        className={styles.image}
      />
      <div>
        <p className={styles.title}>{article.title}</p>
        <p className={styles.description}>{article.shortDescription}</p>
      </div>
    </article>
  );
};

export default ArticleCard;
